import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { BookingCategory } from './booking-types.types'
import { useInvalidateBookingCategories } from './get-booking-categories'

export type CreateBookingCategoryRequest = Pick<BookingCategory, 'name' | 'order'>

export type UpdateBookingCategoryRequest = BookingCategory

export const createBookingCategory = async (data: CreateBookingCategoryRequest) => {
  const response = await authAPI.post<BookingCategory>('/booking-category', data)
  return response.data
}

// Note: BE sets order = Number(order) on every update, so order must always be sent or it becomes NaN
export const updateBookingCategory = async ({ id, ...data }: UpdateBookingCategoryRequest) => {
  const response = await authAPI.put<BookingCategory[]>(`/booking-category/${id}`, data)
  return response.data
}

export const deleteBookingCategory = async (id: number) => {
  await authAPI.delete(`/booking-category/${id}`)
}

export const useCreateBookingCategory = () => {
  const invalidate = useInvalidateBookingCategories()

  return useMutation({
    mutationFn: createBookingCategory,
    onSuccess: invalidate,
  })
}

export const useUpdateBookingCategory = () => {
  const invalidate = useInvalidateBookingCategories()

  return useMutation({
    mutationFn: updateBookingCategory,
    onSuccess: invalidate,
  })
}

export const useDeleteBookingCategory = () => {
  const invalidate = useInvalidateBookingCategories()

  return useMutation({
    mutationFn: deleteBookingCategory,
    onSuccess: invalidate,
  })
}
